// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconWmnt } from "../../../icons/full/build/icon-wmnt.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const WmntIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconWmnt.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  WmntIcon.displayName = 'WmntIcon';
}

export default WmntIcon;